import React from 'react';
import { SolutionPage } from '../../components/solutions/SolutionPage';
import { SolutionDepthSection } from '../../components/solutions/SolutionDepthSection';
export function EmployersPage() {
  return <SolutionPage id="talent" data-id="element-2850" data-mp="1gtkj6b2agedf">
      <SolutionDepthSection id="talent" data-id="element-2851" data-mp="1gs9feb8uf6mb" />
    </SolutionPage>;
}